export const MEDIA_FILTERS = [['all', 'All'], ['photo', 'Photos'], ['video', 'Videos'], ['gif', 'GIFs'], ['boomerang', 'Boomerangs']];
export const mediaLabel = (type) => ({ photo: 'Photo', video: 'Video', gif: 'GIF', burst_gif: 'Burst GIF', boomerang: 'Boomerang' }[type] || 'Media');

export function filterGalleryItems(items, type, search) {
  const query = search.trim().toLowerCase();
  return items.filter((item) => {
    if (!['photo', 'video', 'gif', 'burst_gif', 'boomerang'].includes(item.media_type)) return false;
    if (type !== 'all' && !(type === 'gif' ? ['gif', 'burst_gif'].includes(item.media_type) : item.media_type === type)) return false;
    return !query || `${item.id} ${mediaLabel(item.media_type)}`.toLowerCase().includes(query);
  });
}

export function thumbnailUrl(item, mediaBase) {
  if (item.event_photo) return `${mediaBase}/event_gallery/photo/${encodeURIComponent(item.event_photo)}`;
  if (['gif', 'burst_gif'].includes(item.media_type) && item.event_gif) {
    return `${mediaBase}/event_gallery/${item.media_type === 'burst_gif' ? 'burstgif' : 'gif'}/${encodeURIComponent(item.event_gif)}`;
  }
  return null;
}
